/* src/app/private/modules/learning/learning.component.scss */
.secure-video-container {
  padding: 2rem;
  border-radius: 12px;
}
.secure-video-container .video-wrapper {
  position: relative;
  background: #000;
  border-radius: 8px;
  overflow: hidden;
  height: 70vh;
  width: 100%;
}
.secure-video-container .video-wrapper::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background:
    linear-gradient(
      45deg,
      rgba(255, 0, 0, 0.05) 25%,
      transparent 25%,
      transparent 75%,
      rgba(255, 0, 0, 0.05) 75%,
      rgba(255, 0, 0, 0.05)),
    linear-gradient(
      45deg,
      rgba(255, 0, 0, 0.05) 25%,
      transparent 25%,
      transparent 75%,
      rgba(255, 0, 0, 0.05) 75%,
      rgba(255, 0, 0, 0.05));
  background-size: 60px 60px;
  background-position: 0 0, 30px 30px;
  pointer-events: none;
  z-index: 1;
  opacity: 0.1;
}
.secure-video-container .video-wrapper .security-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 60px;
  z-index: 2;
  cursor: default;
}
.secure-video-container .video-wrapper .secure-video {
  width: 100%;
  height: 100%;
  display: block;
  object-fit: contain;
  pointer-events: none;
  user-select: none;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
}
.secure-video-container .video-wrapper .secure-video::-webkit-media-controls {
  display: none !important;
}
.secure-video-container .video-wrapper .secure-video::-webkit-media-controls-enclosure {
  display: none !important;
}
.secure-video-container .video-wrapper .secure-video::-webkit-media-controls-panel {
  display: none !important;
}
.secure-video-container .video-wrapper .secure-video::--webkit-media-controls-play-button {
  display: none !important;
}
.secure-video-container .video-wrapper .secure-video::-webkit-media-controls-start-playback-button {
  display: none !important;
}
.secure-video-container .video-wrapper .custom-controls {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  background:
    linear-gradient(
      to top,
      rgba(0, 0, 0, 0.9),
      transparent);
  padding: 1rem;
  display: flex;
  align-items: center;
  gap: 1rem;
  z-index: 10;
  -webkit-user-select: none;
  user-select: none;
}
.secure-video-container .video-wrapper .custom-controls .control-btn {
  background: rgba(255, 255, 255, 0.1);
  border: none;
  color: white;
  padding: 0.5rem;
  border-radius: 4px;
  cursor: pointer;
  transition: all 0.3s;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
}
.secure-video-container .video-wrapper .custom-controls .control-btn:hover {
  background: rgba(255, 255, 255, 0.2);
}
.secure-video-container .video-wrapper .custom-controls .control-btn i {
  font-size: 1.2rem;
}
.secure-video-container .video-wrapper .custom-controls .progress-container {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}
.secure-video-container .video-wrapper .custom-controls .progress-container .progress-bar {
  width: 100%;
  height: 6px;
  border-radius: 3px;
  background: rgba(255, 255, 255, 0.2);
  outline: none;
  cursor: pointer;
  -webkit-appearance: none;
  appearance: none;
}
.secure-video-container .video-wrapper .custom-controls .progress-container .progress-bar::-webkit-slider-thumb {
  -webkit-appearance: none;
  appearance: none;
  width: 14px;
  height: 14px;
  border-radius: 50%;
  background: #fff;
  cursor: pointer;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
}
.secure-video-container .video-wrapper .custom-controls .progress-container .progress-bar::-moz-range-thumb {
  width: 14px;
  height: 14px;
  border-radius: 50%;
  background: #fff;
  cursor: pointer;
  border: none;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
}
.secure-video-container .video-wrapper .custom-controls .progress-container .time-display {
  color: rgba(255, 255, 255, 0.8);
  font-size: 0.85rem;
  font-family: monospace;
}
.secure-video-container .video-wrapper .custom-controls .volume-control {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}
.secure-video-container .video-wrapper .custom-controls .volume-control .volume-slider {
  width: 80px;
  height: 4px;
  border-radius: 2px;
  background: rgba(255, 255, 255, 0.2);
  outline: none;
  cursor: pointer;
  -webkit-appearance: none;
  appearance: none;
}
.secure-video-container .video-wrapper .custom-controls .volume-control .volume-slider::-webkit-slider-thumb {
  -webkit-appearance: none;
  appearance: none;
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background: #fff;
  cursor: pointer;
}
.secure-video-container .video-wrapper .custom-controls .volume-control .volume-slider::-moz-range-thumb {
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background: #fff;
  cursor: pointer;
  border: none;
}
.secure-video-container .security-notice {
  margin-top: 1.5rem;
  padding: 1rem;
  background: rgba(239, 68, 68, 0.1);
  border: 1px solid rgba(239, 68, 68, 0.3);
  border-radius: 6px;
  display: flex;
  align-items: center;
  gap: 0.75rem;
  color: #fca5a5;
}
.secure-video-container .security-notice i {
  font-size: 1.5rem;
  color: #ef4444;
}
.secure-video-container .security-notice span {
  font-size: 0.9rem;
  line-height: 1.5;
}
::selection {
  background: transparent;
}
::-moz-selection {
  background: transparent;
}
* {
  -webkit-user-drag: none;
  -khtml-user-drag: none;
  -moz-user-drag: none;
  -o-user-drag: none;
  user-drag: none;
}
.learning-container {
  height: calc(100vh - 100px);
  padding: 1.5rem;
  width: 100%;
}
.learning-container ::ng-deep .p-tabview .p-tabview-nav {
  background: #1e293b;
  border-bottom: 2px solid #334155;
}
.learning-container ::ng-deep .p-tabview .p-tabview-nav .p-tabview-nav-link {
  color: #94a3b8;
  font-weight: 500;
  padding: 1rem 1.5rem;
  transition: all 0.3s ease;
}
.learning-container ::ng-deep .p-tabview .p-tabview-nav .p-tabview-nav-link:hover {
  background: #334155;
  color: #e2e8f0;
}
.learning-container ::ng-deep .p-tabview .p-tabview-nav .p-highlight .p-tabview-nav-link {
  background: #334155;
  color: #fff;
  border-bottom: 2px solid #3b82f6;
}
.learning-container ::ng-deep .p-tabview .p-tabview-panels {
  background: transparent;
  padding: 0;
  border: none;
}
.video-container {
  height: calc(100vh - 100px);
  padding: 0rem;
  width: 100%;
}
.tab-content {
  padding: 1rem;
  min-height: 400px;
  border-radius: 10px;
}
.tab-content h3 {
  font-size: 1.5rem;
  margin-bottom: 1rem;
  color: #1e293b;
}
.tab-content p {
  color: #64748b;
  margin-bottom: 2rem;
}
.tab-content .coming-soon {
  display: flex;
  align-items: center;
  gap: 1rem;
  padding: 1.5rem;
  background: #f1f5f9;
  border-radius: 8px;
  color: #475569;
}
.tab-content .coming-soon i {
  font-size: 1.5rem;
  color: #3b82f6;
}
/*# sourceMappingURL=learning.component.css.map */
